import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { InfoPageTitle } from 'views/common/components';
import StyledBox from 'views/membership-module/TermsAndConditionsView/TermsAndConditionsView.styles';
import { TabsAndConditionsSection } from 'views/membership-module/TermsAndConditionsView/components';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import PATHS from 'lib/navigation/paths';
import getConfig from 'next/config';
import { hotjar } from 'react-hotjar';

const {
  publicRuntimeConfig: { envVars },
} = getConfig();

const TermsAndConditionsView = (props) => {
  const { t } = useTranslation('fe_er_terms_and_conditions_page');
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
        const hotjarEnabledCheck = envVars.HOTJAR_ENABLED === 'true';

        if (hotjarEnabledCheck) {
          hotjar.initialize(envVars.HOTJAR_SITE_ID, 6);
        }
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  const mainTitleObject = {
    name: t('fe_er_terms_and_conditions_page:header'),
  };
  const breadcrumbsObject = {
    links: [
      {
        text: t('fe_er_terms_and_conditions_page:eagle_rider'),
        path: PATHS.home(),
      },
      {
        text: t('fe_er_terms_and_conditions_page:information'),
        path: PATHS.information(),
      },
      {
        text: t('fe_er_terms_and_conditions_page:terms'),
      },
    ],
  };
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);

  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>

      <StyledBox className="overFlowXHidden">
        <InfoPageTitle
          mainTitleObject={mainTitleObject}
          breadcrumbsObject={breadcrumbsObject}
          buttonText={t('fe_er_terms_and_conditions_page:start_reservation')}
        />
        <TabsAndConditionsSection />
      </StyledBox>
    </>
  );
};

export { TermsAndConditionsView };
